import { gql } from '@apollo/client'
import activeHrBusinessPartnersFragment from './fragments/activeHrBusinessPartners.fragment'

export const ACTIVE_HRBPS_BY_COUNTRY = gql`
  query GetHrBusinessPartnersByCountry($country: Country!) {
    getHrBusinessPartnersByCountry(country: $country) {
      ...ActiveHRBusinessPartner
    }
  }
  ${activeHrBusinessPartnersFragment}
`

export const POSSIBLE_COMPANIES_FOR_CREATE_NEW_HRBP = gql`
  query GetPossibleCompaniesForCreateNewHrBusinessPartner {
    getPossibleCompaniesForCreateNewHrBusinessPartner {
      id
      name
    }
  }
`

export const NAME_SEARCH_FOR_HRBP_SELECT = gql`
  query NameSearchForHRBPSelect($country: Country!, $searchString: String!, $limit: Int!) {
    nameSearchForHRBPSelect(country: $country, limit: $limit, rawInput: $searchString) {
      id
      legalFirstName
      legalLastName
      chosenFirstName
      chosenLastName
      buName
      companyName
      avatarUrl
    }
  }
`
